// extracted by mini-css-extract-plugin
module.exports = {"widgetLayoutToolbar":"style_widgetLayoutToolbar__mYaWP","discoveryWidget":"style_discoveryWidget__jNblC"};